export const contentTableConfig = {
  title: '推广素材列表',
  propList: [
    { prop: 'id', label: '素材id', minWidth: '80' },
    { prop: 'typeName', label: '素材类型', minWidth: '80', slotName: 'type' },
    { prop: 'title', label: '素材标题', minWidth: '150' },
    { prop: 'validReplyDuration', label: '回复时限', minWidth: '80' },
    { prop: 'replyKeyword', label: '回复关键词', minWidth: '120' },
    { prop: 'createdTime', label: '创建时间', minWidth: '120', sortable: true },
    { prop: 'createdBy', label: '创建人', minWidth: '80' },
    { prop: 'updatedTime', label: '更新时间', minWidth: '120', sortable: true },
    { prop: 'updatedBy', label: '更新人', minWidth: '80' },
    {
      prop: 'longterm',
      label: '长效素材',
      minWidth: '80',
      slotName: 'longterm'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: true
}
